import { AttributeFilterOption } from "../../../common/interfaces";
import React from "react";
import { Checkbox } from "../Checkbox";

interface AttributeFilterOptionItemProps {
  attributeFilterId: string;
  attributeFilterOption: AttributeFilterOption;
  active: boolean;
  onSelected: () => void;
}

const getAlphanumericId = (str: string) => {
  let parts = str.split(" ");
  parts = parts.filter(p => /[a-zA-Z0-9]+/.test(p));
  return parts.join("-");
};

export const AttributeFilterOptionItem: React.FC<AttributeFilterOptionItemProps> = ({
  attributeFilterId,
  attributeFilterOption,
  active,
  onSelected
}) => {
  const checkboxId = `${attributeFilterId}-${getAlphanumericId(attributeFilterOption.value)}`;

  return (
    <li className="attribute-filter-accordion__attribute-option" key={attributeFilterOption.value}>
      <Checkbox
        inputId={checkboxId}
        checked={active}
        onChange={onSelected}
        data-testid="attribute-filter-item"
        size="sm"
      >
        {attributeFilterOption.label}
      </Checkbox>
    </li>
  );
};
